import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=7dfe932a&scoped=true&"
import script from "./TakePhoto.vue?vue&type=script&lang=js&"
export * from "./TakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./TakePhoto.vue?vue&type=style&index=0&id=7dfe932a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfe932a",
  null
  
)

export default component.exports